import { useCallback, useMemo, useState } from 'react';
import { useApolloClient, useLazyQuery } from '@apollo/client/react';

import { GET_DOCUMENT_SEARCH_RESULT } from 'api/queries/documentQueries';

export const FILTERS = [
	{
		label: 'Signerte dokumenter',
		filter: { var: 'isSigningComplete', value: true },
	},
	{
		label: 'Usignerte dokumenter',
		filter: { var: 'isSigningComplete', value: null },
	},
];

function filterSearchResults(searchResults, searchFilter) {
	if (!searchFilter) return searchResults;

	const filterVar = searchFilter.filter.var;
	const filterValue = searchFilter.filter.value;

	return searchResults.filter(
		item => item.isSigning && item[filterVar] === filterValue
	);
}

export function useDocumentSearch(tenantId) {
	const [searchFilter, setSearchFilter] = useState(null);

	const [
		searchDocumentNodes,
		{ data, loading: loadingSearch, error: searchError },
	] = useLazyQuery(GET_DOCUMENT_SEARCH_RESULT, {
		fetchPolicy: 'network-only',
		errorPolicy: 'all',
	});

	const searchResults = useMemo(
		() =>
			filterSearchResults(data?.searchResult?.items ?? [], searchFilter),
		[data, searchFilter]
	);

	const runSearch = searchValue =>
		searchDocumentNodes({
			variables: {
				tenantId,
				search: searchValue,
			},
		});

	return {
		runSearch,
		searchResults,
		loadingSearch,
		searchError,
		searchFilter,
		setSearchFilter,
		runFilter: setSearchFilter,
	};
}

export function useDocumentSearchRefetchQueries() {
	const client = useApolloClient();

	// Named refetches also run unused lazy queries without tenant variables.
	return useCallback(
		() =>
			[...client.getObservableQueries('active')]
				.filter(query => query.queryName === 'paginateDocumentSearch')
				.map(query => ({
					query: query.query,
					variables: query.variables,
					context: query.options.context,
				})),
		[client]
	);
}
